









import { Icon } from "@timesheets/webapp-support";
import Vue, { PropOptions } from "vue";
import { Methods } from "./Methods";
import { Props } from "./Props";
import { Computed } from "./Computed";
import { Data } from "./Data";
import "./scss";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { IQueryOptions } from "../QueryOptions";
import { TypedEvent } from "@gemma/events";
import { Position } from "@/utils";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SortableHeader",
  props: {
    fieldName: {
      type: String,
      required: false,
    } as PropOptions<string>,
    fieldSortName: {
      type: String,
      required: false,
    } as PropOptions<string>,
    sorting: {
      type: Object,
      required: true,
    } as PropOptions<Props["sorting"]>,
    groupedQueryOptionsId: {
      type: String,
      required: true,
    } as PropOptions<string>,
    position: {
      type: String,
      default: () => Position.Right,
    } as PropOptions<Position>,
  },
  computed: {
    fieldSortName_(): string {
      return this.fieldSortName || (this.fieldName && this.fieldName.toLowerCase());
    },
    classes() {
      const current = this.sorting.current === this.fieldSortName_;

      return {
        current,
      };
    },
    icon() {
      const direction = this.sorting.fields[this.fieldSortName_]["direction"];
      const icon = this.sorting.icon[direction];

      return icon as Icon;
    },
  },
  methods: {
    async requestResort<TFilter extends Record<string, unknown>>(this: IQueryOptions<TFilter>, fieldName: string): Promise<unknown[]> {
      const event = new TypedEvent("requestResort", {
        //
        groupedQueryOptionsId: this.groupedQueryOptionsId,
        fieldName,
      });
      return WebApplicationConstants.listenerEventBuses.system.emit(event);
    },
  },
});
